import axiosClient from "../../network";

export default class cmsService {
  static getCmsData(params) {
    return axiosClient
      .get("/user/getCms", {
        params
      })
      .then(([data]) => {
        return data;
      })
      .catch((error) => {
        if (error.data) {
          return { error: error.data };
        }
        return {
          error
        };
      });
  }
}
